module.exports = __webpack_public_path__ + "assets/images/office_title.e1dc7014365840fe8ed86ba17b663f0f.png";